import { FC } from 'react'
import { Box, Button } from '@maas-components/core'
import { MaasErrorBoundary, TErrorBoundaryPageOptions } from 'lib/maasErrorBoundary'

const ResetButton = ({ resetErrorBoundary }: { resetErrorBoundary: () => void }) => (
  <Box py={2}>
    <Button onClick={resetErrorBoundary} variant="contained" color="primary">
      Tentar novamente
    </Button>
  </Box>
)

const AppError: FC = ({ children }) => {
  const path = `${window.location.pathname}${window.location.search}`

  const pageOptions: TErrorBoundaryPageOptions = resetErrorBoundary => ({
    Forbidden: {
      button: <ResetButton resetErrorBoundary={resetErrorBoundary} />,
      buttonText: 'Tentar novamente',
      buttonUrl: path,
      message:
        'Você precisa de permissão para acessar esta página. Verifique sua conexão com a VPN ou entre em contato com a área responsável para obter informações.',
    },
    InternalError: {
      button: <ResetButton resetErrorBoundary={resetErrorBoundary} />,
    },
  })

  return (
    <MaasErrorBoundary errorPageOptions={pageOptions} resetKeys={[path]}>
      {children}
    </MaasErrorBoundary>
  )
}

export default AppError
